import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import * as yup from 'yup';
import { useFormik } from 'formik';
import "./SignIn.scss";
import { ApiClient } from '../../lib/ApiClient';
import { UrlHelpers } from '../../lib/Helpers';
import { useAuthenticated } from '../auth/useAuthenticated'
import { loginWithRecoveryCode } from './2faEndpoints';
import { getUrl } from '../../domain';

const apiClient = new ApiClient();

export default function SignInWith2faRecoveryCode() {
    let returnUrl = getUrl(UrlHelpers.getSafeUrl(new URLSearchParams(window.location.search).get('ReturnUrl') || "", "/account/logout"));
    const userAuth = useAuthenticated(apiClient);
    const [showFormError, setShowFormError] = React.useState(false);
    const [errorMessage, setErrorMessage] = React.useState(null);

    if (!userAuth.isAuthenticating && userAuth.isAuthenticated) {
        window.location = returnUrl;
    }

    const initialValues = { code: '' };
    const validationSchema = yup.object({
        code: yup
            .string('Enter your recovery code')
            .required('Recovery code is required'),
    });

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            try {
                setShowFormError(false);
                setErrorMessage(null);
                await loginWithRecoveryCode(values.code);
                window.location = returnUrl;
            }
            catch(err) {
                setShowFormError(true);
                if (err.response?.data?.errorMessage) {
                    setErrorMessage(err.response.data.errorMessage);
                }
                else {
                    setErrorMessage("The code is incorrect");
                }
            }
            finally {
                formik.setSubmitting(false);
            }
        },
    });

    return (
        <>
            <Box
                sx={{
                    marginTop: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <form onSubmit={formik.handleSubmit}>
                    {showFormError && (
                        <Alert sx={{ mt: 2 }} severity="error">{errorMessage}</Alert>
                    )}
                    <TextField sx={{ mt: 2 }}
                        type="text"
                        name="code"
                        label="Recovery Code"
                        data-cy-id="signIn2faRecoveryCode-form-code"
                        fullWidth
                        value={formik.values.code}
                        onChange={formik.handleChange}
                        error={formik.touched.code && Boolean(formik.errors.code)}
                        helperText={formik.touched.code && formik.errors.code}
                    />
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        data-cy-id="signIn2faRecoveryCode-form-submit"
                        disabled={formik.isSubmitting}
                        sx={{ mt: 2, mb: 2 }}
                    >
                        Sign In
                    </Button>
                </form>
            </Box>
        </>
    );
}